<template>
  <div>
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th>
              Member Type
            </th>
            <th>
              Description
            </th>
            <th colspan="2">Selection</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="memberType of memberTypes"
            :key="memberType.value"
            :value="memberType.value"
          >
            <td>{{ memberType.name }}</td>
            <td width="30%">
              <p v-if="memberType.description">{{ memberType.description }}</p>
              <p v-if="memberType.agreementUrl">
                Please review the <a :href="memberType.agreementUrl" target="_blank">{{ memberType.name }} license agreement.</a>
              </p>
              <p v-else>
                Please review the <a :href="LICENSE_AGREEMENT_GENERIC" target="_blank">MLA Terms and Conditions.</a>
              </p>
            </td>
            <td width="10%">
              <v-checkbox
                :input-value="selection.includes(memberType.value)"
                @change="onSelect(memberType.value, $event)"
                color="primary"
              ></v-checkbox>
            </td>
            <td width="30%">
            <v-select
              v-if="!!memberType.subTypes"
              v-show="memberType.subTypes.length > 0"
              v-model="subTypeSelection[memberType.value]"
              :disabled="!selection.includes(memberType.value)"
              :items="memberType.subTypes"
              :item-disabled="item => !item.isActive"
              item-text="name"
              item-value="value"
            >
            </v-select>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-spacer />
    <v-btn
      name="activity-select-next"
      color="primary"
      :disabled="!valid"
      :loading="saving"
      @click="submit"
    >
      Next
    </v-btn>
  </div>
</template>

<style scoped>
span.break-spaces {
  white-space: break-spaces;
}
</style>

<script>
import gql from 'graphql-tag'
import { MemberType } from '@mymsa/common'

import { LICENSE_AGREEMENT_GENERIC } from '../utilities/env.js'

export default {
  name: 'RegistrationMemberTypeSelect',

  props: {
    registrationId: {
      type: String,
      required: true
    }
  },

  data: () => ({
    LICENSE_AGREEMENT_GENERIC,
    selection: [],
    subTypeSelection: {},
    MemberType,
    memberTypes: [],
    saving: false
  }),

  computed: {
    selectedMemberTypes () {
      return Object.entries(this.selection)
        .filter(([k, v]) => v)
        .map(([k]) => k)
    },
    valid () {
      return this.selectedMemberTypes.length > 0
    }
  },

  apollo: {
    registration: {
      query: gql`query GetRegistrationActivitiesForSubmit($id: MongoID!) {
        registration: registrationById(_id: $id) {
          _id
          activities {
            _id
            type
            subType
          }
        }
      }`,
      variables () {
        return {
          id: this.registrationId
        }
      },
      result ({ data }) {
        if (!data) return
        const { activities } = data.registration
        this.selection = activities.map(activity => activity.type)
        this.subTypeSelection = Object.fromEntries(activities.map(activity => [activity.type, activity.subType]))
      },
      error (e) { this.onError(e) }
    },
    memberTypes: {
      query: gql`query($filter: FilterFindManyMemberTypeInput!) {
        memberTypes: memberTypeMany(limit: 0, filter: $filter, sort: NAME_ASC) {
          _id
          name
          value
          agreementUrl
          description
          subTypes {
            _id
            value
            name
            isActive
          }
        }
      }`,
      variables () {
        return {
          filter: {
            enableSelfRegistration: true
          }
        }
      },
      error (e) { this.onError(e) }
    }
  },

  methods: {
    onError (e) {
      this.$emit('error', e)
    },
    onSelect (key, value) {
      if (value) {
        this.selection.push(key)
      } else {
        this.selection.splice(this.selection.indexOf(key), 1)
      }
    },
    async submit () {
      this.saving = true

      const activities = this.selection.map(type => {
        const activity = {
          ...this.registration.activities.find(o => o.type === type),
          type,
          subType: this.subTypeSelection[type]
        }
        return activity
      })

      try {
        await this.$apollo.mutate({
          mutation: gql`mutation UpdateRegistrationActivitySelection ($id: MongoID!, $record: UpdateByIdRegistrationInput!) {
            registrationUpdateById(_id: $id, record: $record){
              record {
                _id
                activities {
                  _id
                  type
                  subType
                }
              }
            }
          }`,
          variables: {
            id: this.registrationId,
            record: {
              activities
            }
          }
        })
      } catch (e) {
        this.onError(e)
        return
      } finally {
        this.saving = false
      }
      this.$emit('change')
    }
  }
}
</script>
